export const nonEmpty = (value?: string) => value != null && value !== "";
